import React from "react"
import dynamic from "next/dynamic"
import { Box } from "@chakra-ui/react"
import Wrapper from "components/layout/wrapper"
import { loadCustomComponent } from "lib/componentLoader"

const Body = dynamic(() => import("components/matrix/body"))
const AccordionComponent = dynamic(() => import("components/matrix/accordion"))
const TwoColumn = dynamic(() => import("components/matrix/twoColumn"))
const Row = dynamic(() => import("components/matrix/row"))
export default function WrapperBlock({ block, colorMode }) {
    // const gapHorizontal = block.gapHorizontal ? block.gapHorizontal : "20px"
    // const gapVertical = block.gapVerticalMobile ? block.gapVerticalMobile : "10px"

    function renderSwitch(block) {
        switch (block.type) {
            case "body": {
                return (
                    <Box className="body">
                        <Body block={block} colorMode="dark" />
                    </Box>
                )
            }
            case "accordion": {
                return (
                    <Box className="body">
                        <AccordionComponent block={block} colorMode="dark" />
                    </Box>
                )
            }
            case "twoColumn": {
                return <TwoColumn block={block} colorMode={colorMode} />
            }
            case "row": {
                return <Row block={block} colorMode={colorMode} />
            }
            case "customComp": {
                const Component = loadCustomComponent(block.component)
                return <Component block={block} colorMode={colorMode} />
            }
        }
    }

    return (
        <Wrapper
            className={`wrapperMatrixBlock colorMode--${colorMode} ${block.customClass ? block.customClass : null}`}
            py="10px"
        >
            <Box>
                {block.entries.map((contentBlock, i) => {
                    return (
                        <React.Fragment key={i}>
                            <Box flexGrow={1} flexShrink={1} flexBasis={0} className={`box-` + i}>
                                {contentBlock.pageMatrix.map((block, ii) => (
                                    <Box key={ii}>{renderSwitch(block)}</Box>
                                ))}
                            </Box>
                            {block.verticalColumnDivider && i < block.entries.length - 1 && (
                                <Box flex="0 1 auto" padding={0}>
                                    <Box width="1px" className="verticalDivider" height="100%"></Box>
                                </Box>
                            )}
                        </React.Fragment>
                    )
                })}
            </Box>
        </Wrapper>
    )
}
